import React from 'react';

import { IForm } from '@entities/AdminConversationCategory/model/types';
import { htmlParser } from '@shared/helpers';
import { CustomModal, Image, UiButton, UiText } from '@shared/ui';
import { doneAction } from '@widgets/ConversationBanner/api/doneAction';

import cls from './Newsletter.module.css';

interface NewsletterProps {
    classes?: string;
    prevData?: IForm;
}

export const Newsletter = ({ classes, prevData }: NewsletterProps) => {
    // @ts-ignore
    const newsletterData = modalData;

    const onButtonClick = (id: number, url: string) => {
        window.open(url, '_blank', 'noopener,noreferrer');

        if (!prevData) {
            void doneAction(id);
        }
    };

    return (
        <>
            <CustomModal.Body classes={cls.NewsletterBody}>
                {(prevData?.image || newsletterData.image) && (
                    <Image
                        wrapperClassName={cls.imageWrapper}
                        className={cls.image}
                        height={248}
                        width={440}
                        src={
                            prevData?.image
                                ? prevData?.image.originalUrl
                                : newsletterData.image.original_url
                        }
                    />
                )}
                <UiText classes={cls.description} variant="subPlain">
                    {htmlParser(prevData ? prevData.description : newsletterData.description)}
                </UiText>
            </CustomModal.Body>
            <CustomModal.Footer classes={cls.footer}>
                {/* @ts-ignore */}
                {{ ...(prevData || newsletterData) }.actions.map((action, index) => (
                    <UiButton
                        key={action.id}
                        onClick={() => onButtonClick(action.id, action.url)}
                        btnText={action.text}
                        btnColor={index === 0 ? 'primary' : 'secondary'}
                    />
                ))}
            </CustomModal.Footer>
        </>
    );
};
